import React from 'react';
import Routes from './routes';

import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';

import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

// se remover login fica zoado
import 'bootstrap/dist/css/bootstrap.css';

import 'devextreme/dist/css/dx.common.css';
import './assets/dx.material.integration.css';
import './assets/global.css';

datadogRum.init({
  applicationId: '248266f1-f5b9-46cb-aac4-da2a88739d06',
  clientToken: 'pubc004e6edcf62f6221a6744e976ef1114',
  site: 'us3.datadoghq.com',
  service: 'scheduling',
  env: 'production',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  defaultPrivacyLevel: 'mask-user-input',
});

// Logs da aplicação (datadogLogs.logger) no mesmo serviço do RUM, ligados à
// sessão. Também saem no console do navegador, para quem depura localmente.
datadogLogs.init({
  clientToken: 'pubc004e6edcf62f6221a6744e976ef1114',
  site: 'us3.datadoghq.com',
  service: 'scheduling',
  env: 'production',
  sessionSampleRate: 100,
});
datadogLogs.logger.setHandler(['http', 'console']);

datadogRum.setUser({
      name: localStorage.getItem('userName') || null,
    });
function App() {
  const theme = createTheme({
    palette: {
      primary: {
        main: '#8b0305',
      },
    },
  });

  return (
    <MuiThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Routes />
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  );
}

export default App;
